<template>
    <div id="policyHelp" class="help-right">
        <div class="head">
            <div class="lr-grid">
                <h2>{{ $t('POLICY.LABEL.POLICY_TOOLTIP') }}</h2>
                <button class="buttons-icon help-close"
                        data-icon="close"
                        data-size="l"
                        data-trigger="close"
                        data-type="ghost"
                        type="button"
                        v-on:click="closeHelp()">{{ $t('LABEL.CLOSE') }}
                </button>
            </div>
            <div class="search-bar">
                <input v-model="srchTextModel"
                    :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')"
                    type="search"
                    v-on:keyup="debounceSearchText">
                <em class="icon"></em>

                <button class="buttons-icon" data-icon="clear" data-size="s" data-type="ghost" type="button"
                        v-on:click="srchTextModel=''">Reset
                </button>
            </div>

            <div class="tag-wrap">
                <button class="icon-tag" data-type="policy-custom" v-on:click="srchTextModel='Cost'">Cost</button>
                <button class="icon-tag" data-type="policy-custom" v-on:click="srchTextModel='Asset'">Asset</button>
                <button class="icon-tag" data-type="policy-custom" v-on:click="srchTextModel='Performance'">
                    Performance
                </button>
                <button class="icon-tag" data-type="policy-custom" v-on:click="srchTextModel='Security'">Security
                </button>
            </div>

        </div>

        <!--

        data-policy list일때 리스트 노출
        data-policy view일때 선택된 정책 노출
        data-policy search일대 search된 결과값 노출

        -->

        <div :data-policy="curType" class="contents">
            <div v-if="curType === constants.GUIDE_VIEW_TYPE.VIEW" class="policy-list-back">

                <button class="buttons" data-icon="back" data-size="s" data-type="ghost" type="button"
                        v-on:click="goPolicyList()">정책보기
                </button>
            </div>
            <div class="search-text">
                <p>{{ getSearchCount }} {{ $t('POLICY.RULE.SEARCH_RESULT_FOUND') }}</p>
            </div>
            <div class="policy-common policy-list">
                <div class="information">
                    <h3>{{ $t('POLICY.LABEL.POLICY_IS') }}</h3>
                    <p class="info">{{ $t('POLICY.LABEL.POLICY_DESC') }}</p>
                    <button class="buttons export" data-icon-right="open" data-type="ghost" type="button"
                            v-on:click="openGuideForCreatePolicy()"><span
                        class="open">{{ $t('POLICY.BUTTON.OPEN_POLICY_GUIDE') }}</span></button>
                    <div class="detail">
                        <h3>{{ $t('POLICY.LABEL.POLICY_VIEW') }}</h3>
                        <nav class="navigation-tab" data-size="s">
                            <button class="tab-item"
                                    type="button"
                                    v-bind:class="{ 'selected' : srchVendor === ''}"
                                    v-on:click="setSearchVendor('')">{{ $t('HEADER.NOTICE.MORE') }}
                            </button>
                            <button class="tab-item"
                                    type="button"
                                    v-bind:class="{ 'selected' : srchVendor === constants.VENDOR.AWS}"
                                    v-on:click="setSearchVendor(constants.VENDOR.AWS)">AWS
                            </button>
                            <button class="tab-item"
                                    type="button"
                                    v-bind:class="{ 'selected' : srchVendor === constants.VENDOR.AZURE}"
                                    v-on:click="setSearchVendor(constants.VENDOR.AZURE)">Azure
                            </button>
                        </nav>
                        <div class="select-wrap">
                            <select-box-multi :place-holder="$t('FILTER.CATEGORY')"
                                              :select-box-options="getCtgLabelFilterData"
                                              :select-box-value="ctgFilterList"
                                              :use-labels="true"
                                              :use-translate="false"
                                              select-class="type-tagging size-s"
                                              select-id="help-select-ctg"
                                              @onSelectChange="ctgFilterList = $event.value"></select-box-multi>
                            <select-box-multi :place-holder="$t('FILTER.PRODUCT')"
                                              :select-box-options="getProdFilterData"
                                              :select-box-value="prdFilterList"
                                              :use-labels="true"
                                              :use-translate="false"
                                              select-class="type-tagging size-s"
                                              select-id="help-select-prd"
                                              @onSelectChange="prdFilterList = $event.value"></select-box-multi>
                        </div>
                    </div>
                </div>
                <h3 class="search-text-heading" v-if="getPolicyList.length > 0">{{ $t('AUDIT.FILTER.POLICY') }}</h3>
                <div-loading v-if="isLoading"></div-loading>
                <ul class="policy-detail-list">

                    <li v-for="(plcy, plcyIdx) in getPolicyList" v-on:click="showDetail(plcy)" :key="plcyIdx">
                        <!-- {{plcy}} -->
                        <template v-for="(prod, prodIdx) in getProductListOfRule(plcy)">
                            <span :data-vendor="getVendorIcon(prod.vendor)" class="icon-vender" :key="prodIdx"/>
                        </template>
                        <text-highlight :queries="highLightQueries">{{ plcy[$i18n.locale + 'Title'] }}</text-highlight>
                        <p>
                            <text-highlight :queries="highLightQueries">{{ plcy[$i18n.locale + 'Desc'] }}
                            </text-highlight>
                        </p>
                        <span class="icon-detail-disclosure"></span>
                    </li>
                </ul>
            </div>
            <div v-if="getDetailPolicyRuleList.length > 0" class="policy-common policy-view">
                <div class="information">
                    <template v-for="prod in getProductListOfRule(detailPlcy)">
                        <span :data-vendor="getVendorIcon(prod.vendor)" class="icon-vender"/>
                    </template>
                    <h3>{{ detailPlcy[$i18n.locale + 'Title'] }}</h3>
                    <p class="info">{{ detailPlcy[$i18n.locale + 'Desc'] }}</p>
                </div>
                <h3 class="search-text-heading">{{ $t('AUDIT.FILTER.RULE') }}</h3>
                <ul class="policy-detail-view">
                    <li v-for="rule in getDetailPolicyRuleList">
                        <h4>
                            <text-highlight :queries="highLightQueries">{{
                                    rule[$i18n.locale + 'RuleTitle']
                                }}
                            </text-highlight>
                        </h4>
                        <dl>
                            <dt>{{ $t('LABEL.PRODUCT') }}<!--제품--></dt>
                            <dd>
                                <template v-for="prod of getProductListOfRule(rule)">
                                    <span :data-vendor="getVendorIcon(prod.vendor)" class="icon-vender" data-size="s">
                                        {{ $t('PRODUCT.' + prod.prod) }}
                                    </span>
                                </template>
                            </dd>
                            <dt>{{ $t('LABEL.SEVERITY') }}<!--심각도--></dt>
                            <dd>
                                <div class="urgency-wrap">
                                    <span :data-severity="rule.svrty" class="urgency">

                                        <em></em>
                                        <em></em>
                                        <em></em>
                                        <em></em>
                                    </span>
                                    <span>
                                        {{ getSeverityLabel(rule) }}
                                    </span>
                                </div>
                            </dd>
                            <dt>
                                {{ $t('LABEL.DESCRIPTION') }}<!--설명-->
                            </dt>
                            <dd>
                                <p>
                                    <text-highlight :queries="highLightQueries">
                                        {{ rule[$i18n.locale + 'RuleDesc'] }}
                                    </text-highlight>
                                </p>
                            </dd>
                            <dt>{{ $t('POLICY.LABEL.REMEDIATION') }}<!--개선방법--></dt>
                            <dd>
                                <text-highlight :queries="highLightQueries">
                                    {{ rule[$i18n.locale + 'RuleRemd'] }}
                                </text-highlight>
                            </dd>
                        </dl>
                    </li>
                </ul>
                <div class="support">
                    <button class="buttons export" data-icon-right="open" data-type="ghost" type="button"
                            v-on:click="showGuide()"><span
                        class="open">{{ $t('POLICY.BUTTON.GO_TO_USER_GUIDE') }}</span></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PolicySelectBoxMulti from "../common/PolicySelectBoxMulti.vue";
import {EventBus} from "../common/event-bus";
import _ from "lodash";
import {mapGetters} from "vuex";

export default {
    name: 'policyHelp',
    components: {'select-box-multi': PolicySelectBoxMulti},
    data: function () {
        return {
            categoryList: [],       // 현재 회사에서 사용중인 카테고리 리시트
            ctgFilterList: [],      // 카테고리 필터 리스트
            prdFilterList: [],      // 제품 필터 리스트
            srchVendor: '',
            srchText: '',           // 검색 텍스트
            srchTextModel: '',      // 엘리먼트 v모델에 직접 바인딩되는 변수 (Enter 처리를 위해 분리)
            curType: 'list',        // list: 리스트, view: 선택된 정책 상세정보, search: 검색 결과
            detailPlcy: {},         // 상세정보 조회중인 정책 정보
            bestPracticeList: [],   // 기본 정책 리스트
            highLightQueries: [],   // 검색 하이라이팅 대상 텍스트
            pending: false,        // API 호출 시 Pending 상태 플래그
            iconVendor: 'aws',
            isLoading: true,
        }
    },
    created: function () {
        this.getGuideListInfo()
        this.selectCategoryList()
        this.debounceSearchText = _.debounce(this.setSearchTxt, 1000);
    },
    destroyed: function () {
        // 페이지 벗어날 때 body 도움말 클래스 제거
        $('body').removeAttr('data-help')
    },
    watch: {
        srchTextModel: function () {
            this.srchText = this.srchTextModel;
        },
        srchText: function () {
            this.srchTextModel = this.srchText
            this.highLightQueries = [this.srchText]

            this.typeChange(this.srchText !== '' ? this.constants.GUIDE_VIEW_TYPE.SEARCH : this.constants.GUIDE_VIEW_TYPE.LIST)
        }
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
        getRkey: function () {
            return this.rKey
        },
        getLocale: function () {
            return this.$i18n.locale
        },
        getTemplateList: function () {
            return this.$store.state.templateList
        },
        getPolicyList: function () {
            let filtered = this.bestPracticeList
            // Text filter
            if (this.srchText !== '') {
                filtered = filtered.filter((item) => {
                    return (item[this.$i18n.locale + 'Title'] || "").toLowerCase().includes(this.srchText.toLowerCase()) ||
                        (item[this.$i18n.locale + 'Desc'] || "").toLowerCase().includes(this.srchText.toLowerCase()) ||
                        _.includes(item.ctgLabel, this.srchText.toLowerCase())
                })
            }

            // Category filter
            if (this.ctgFilterList.length > 0) {
                filtered = filtered.filter((item) => {
                    for (let srchCtg of this.ctgFilterList) {
                        if (_.includes(item.ctgLabel, srchCtg)) {
                            return true
                        }
                    }
                    return false
                })
            }

            // Product filter
            if (this.prdFilterList.length > 0) {

                filtered = filtered.filter((item) => {
                    let fill = item.cndVal.filter((cnd) => {
                        let ruleProd = _.find(this.getTemplateList, {'tmpltId': cnd.tmpltId})
                        for (let srchProd of this.prdFilterList) {
                            if (ruleProd != null && ruleProd.prod === srchProd) {
                                return true
                            }
                        }
                        return false

                    })
                    return fill.length > 0
                })
            }


            //Vendor filler


            filtered = filtered.filter((item) => {
                return (this.fiterByVendor(item))
            })

            filtered = _.unionBy(filtered, 'plcyId')
            if (filtered.length !== 0) {
                this.isLoading = false;
            }

            return filtered

        },
        getDetailPolicyRuleList: function () {
            let filtered = this.bestPracticeList
            // Text filter
            filtered = filtered.filter((item) => {
                return this.curType === this.constants.GUIDE_VIEW_TYPE.VIEW
                    ? item.plcyId === this.detailPlcy.plcyId
                    : (item[this.$i18n.locale + 'RuleTitle'] || "").toLowerCase().includes(this.srchText.toLowerCase()) ||
                    (item[this.$i18n.locale + 'RuleDesc'] || "").toLowerCase().includes(this.srchText.toLowerCase()) ||
                    (item[this.$i18n.locale + 'RuleRemd'] || "").toLowerCase().includes(this.srchText.toLowerCase()) ||
                    _.includes(item.ctgLabel, this.srchText.toLowerCase())
            })

            filtered = _.unionBy(filtered, 'ruleRvsnId')
            return filtered
        },
        getCtgLabelFilterData: function () {
            let self = this
            let ctgFilter = [];
            if (this.bestPracticeList.length > 0 &&
                typeof (_.head(this.getTemplateList)) !== this.constants.TYPE.UNDEFINED) {
                this.bestPracticeList.forEach(function (r) {
                    for (let ctg of r.ctgLabel) {
                        let category = _.find(self.categoryList, {ctgId: ctg})
                        if (typeof (category) !== "undefined") {
                            ctgFilter.push({
                                key: ctg,
                                val: category.constructor === Object ? category.ctgLabel : ctg
                            })
                        }
                    }
                })
            }

            return _.unionBy(ctgFilter, 'key');
        },
        getProdFilterData: function () {
            let self = this
            let prodFilter = [];
            if (this.bestPracticeList.length > 0 &&
                typeof (_.head(this.getTemplateList)) !== this.constants.TYPE.UNDEFINED) {
                this.bestPracticeList.forEach(function (r) {
                    if (self.fiterByVendor(r)) {
                        for (let cnd of r.cndVal) {
                            let ruleProd = _.find(self.getTemplateList, {'tmpltId': cnd.tmpltId})
                            if (ruleProd != null) {
                                prodFilter.push({
                                    key: ruleProd.prod,
                                    val: self.$t('PRODUCT.' + ruleProd.prod),
                                    dataIcon: self.iconVendor
                                })
                            }
                        }
                    }
                })
            }
            return _.unionBy(prodFilter, 'key');
        },
        getSearchCount: function () {
            return this.getPolicyList.length + this.getDetailPolicyRuleList.length
        },

    },
    methods: {
        getGuideListInfo: function () {

            this.pending = true

            let url = `/api/governance/policy/guide`;

            this.http.get(url)
                .then(result => {
                    return result.data;
                })
                .then(json => {

                    for (let rule of json.result) {
                        rule.cndVal = JSON.parse(rule.cndVal)
                        rule.actnVal = JSON.parse(rule.actnVal)
                        rule.ctgLabel = JSON.parse(rule.ctgLabel)

                    }

                    this.bestPracticeList = json.result;
                    this.pending = false
                })
        },
        selectCategoryList() {
            var url = `/api/governance/category/list/simple`;
            var body = {
                "cmpnId": this.curCmpnId
            };

            this.http.post(url, body)
                .then(response => {
                    this.categoryList = response.data.result;
                });
        },
        setSearchTxt: function () {
            this.srchText = this.srchTextModel;
        },
        setSearchVendor: function (value) {
            this.srchVendor = value;

        },
        getVendorIcon(value) {
            switch (value.toLowerCase()) {
                case this.constants.VENDOR.AZURE.toLowerCase():
                    return "azure"

                default:
                    return value.toLowerCase();
            }
        },
        getVendorUniq(vendors) {
            return _.uniq(vendors, true);
        },
        closeHelp: function () {
            EventBus.$emit('closeViewPolicyHelp');
        },
        // Guide
        showGuide: function () {
            window.open(`/docs/console/${this.getLocale}/user-guide-console-${this.getLocale}.html`);
        },
        //freshservice Site로 이동
        moveSupport: function () {
            window.open(this.urls.supportUrl)
        },
        openGuideForCreatePolicy: function () {
            let guideTag;
            switch (this.getLocale) {
                case 'ko':
                    guideTag = '%EC%A0%95%EC%B1%85-%EC%83%9D%EC%84%B1%ED%95%98%EA%B8%B0'
                    break;
                default:
                    guideTag = 'creating-a-policy'
            }
            window.open(`/docs/console/${this.getLocale}/user-guide-console-${this.getLocale}.html#${guideTag}`)
        },
        showDetail: function (plcy) {
            this.detailPlcy = plcy
            this.typeChange(this.constants.GUIDE_VIEW_TYPE.VIEW)
        },
        typeChange: function (type) {
            this.curType = type
        },
        // 심각도 다국어 항목 가져오기
        getSeverityLabel(rule) {
            return this.$t("LABEL.SVRTY." + rule.svrty)
        },
        // 룰에 해당되는 제품명 리스트 가져오기
        getProductListOfRule(rule) {
            let prodArray = [];
            if (this.getTemplateList && this.getTemplateList.length > 0) {
                if (rule.cndVal != null) {
                    for (let condition of rule.cndVal) {
                        let conditionProd = _.find(this.getTemplateList, {'tmpltId': condition.tmpltId})
                        if (conditionProd != null) {
                            prodArray.push({
                                key: conditionProd.prod + "_" + conditionProd.vendor,
                                prod: conditionProd.prod,
                                vendor: conditionProd.vendor
                            })
                        }
                    }
                    prodArray = _.uniqBy(prodArray, 'key');
                }

            }
            return prodArray
        },
        goPolicyList: function () {
            this.typeChange(this.srchText !== '' ? this.constants.GUIDE_VIEW_TYPE.SEARCH : this.constants.GUIDE_VIEW_TYPE.LIST)
        },
        fiterByVendor(item) {
            if (this.srchVendor === '') return true;
            for (let condition of item.cndVal) {
                let conditionProd = _.find(this.getTemplateList, {'tmpltId': condition.tmpltId});
                if (conditionProd != null && conditionProd.vendor === this.srchVendor.toUpperCase()) return true;
            }
            return false;
        }

    }
}
</script>

<style scoped>
[data-vendor]:before {
    margin: 0
}
.policy-detail-list,
.policy-detail-view {
    height: 100%;
    max-height: 100% !important;
    overflow: auto;
    width: 340px;
    padding-right: 20px;
}
.policy-common.policy-list,
.policy-common.policy-view {
    height: 100%;
    overflow: auto;
    width: 340px;
    padding-right: 20px;
}
.contents {
    height: 100%;
}
.policy-detail-view li dl dd * {
    word-break: break-word !important;
}
</style>



// WEBPACK FOOTER //
// src/components/policy/policyHelp.vue